import React from 'react';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_EVENING_DISCOUNT } from '../../util/types';

import css from './BookingBreakdown.css';

const LineItemEveningDiscountMaybe = props => {
  const { transaction, intl } = props;

  const items = transaction.attributes.lineItems.filter(item => {
    if (!item) return;

    return item.code === LINE_ITEM_EVENING_DISCOUNT && !item.reversal
  }
  );

  const label = intl.formatMessage({id: "BookingBreakdown.eveningDiscountLabel" });

  return items.length > 0 ? (
    <React.Fragment>
      {items.map((item, i) => {
        const formattedTotal = formatMoney(intl, item.lineTotal);
        return (
          <div key={`${i}-item.code`} className={css.lineItem}>
            <span className={css.itemLabel}>{label}</span>
            <span className={css.itemValue}>{formattedTotal}</span>
          </div>
        );
      })}
    </React.Fragment>
  ) : null;
};

export default LineItemEveningDiscountMaybe;
